
var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedresources",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_who: null,
	_permissions: {},

	reset: reset,
	recalculate: recalculate,
	trackChanges: trackChanges,
	listResources: listResources,
	load: load
});

function init() {
	this._rawList = [];
	this._viewingResource = null;
	this._tracker = this.dispatcher.createTracker();
	this.reset();
}

function uninit() {
	this._tracker.off();
	this._tracker = null;
}

function triggers() {
	return {
		"reset": reset,
		"view": view,
		"load": load,
		"viewresource": viewResource,
		"closeresource": closeResource,

		"edit:start": startEditResources,
		"edit:finish": finishEditResources,
		"edit:cancel": cancelEditResources
	};
}

function listeners() {
	return {
		"managedresourceslist:updated": Model.makeRecalculator("resourcesList"),
		"managementpermissions:updated": handlePermissionUpdate
	};
}

function recalculate(){
	var resourceList = this._resourcesList;
	var rawList = this._rawList;
	var currentViewing = this._viewingResource;

	if(!this._viewing) return;

	var newResources = rawList.reduce(function(arr, resource){
		var newResource = resourceList[resource];
		if(newResource) arr = arr.concat(newResource);
		return arr;
	}, []);

	var update = {
		resources: newResources
	};

	var newViewing = resourceList[currentViewing];
	if(currentViewing && newViewing)
		update.resourceDetail = newViewing;

	this.extend(update);
}

function listResources(who, shouldOpen) {
	this._who = who;
	const group = this._group;
	this.api.manage.resources.list(who, group)
		.then(updateList.bind(this, shouldOpen));
}

function updateList(shouldOpen, data) {
	this._rawList = data;
	this.recalculate();
	this.dispatch("loaded");
	if(shouldOpen)
		this.dispatch("open");
}

function view(who) {
	this.load(who, true);
	this.emit("usermetrics:trigger:track", "view managed user's resources", {
		...who,
	});
}

function load(who, shouldOpen){
	const resourcePermission = this._permissions?.resources;
	if(resourcePermission === 0) return;
	var whoId = who.who;
	var group = who.group;
	this.listResources(whoId, shouldOpen);
	this.trackChanges(whoId);
	this._viewing = true;
	this._group = group;
}

function trackChanges(who){
	var tracker = this._tracker;
	var group = this._group;

	tracker.off();

	if(group) {
		if(Array.isArray(group)) {
			group.forEach(g=>{
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/resource/added", handle_resource_added.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/resource/removed", handle_resource_removed.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/resource/set", handle_resources_set.bind(this));
			});
		} else {
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/resource/added", handle_resource_added.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/resource/removed", handle_resource_removed.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/resource/set", handle_resources_set.bind(this));
		}
	} else {
		tracker.on("mqtt:u/" + who + "/resource/added", handle_resource_added.bind(this));
		tracker.on("mqtt:u/" + who + "/resource/removed", handle_resource_removed.bind(this));
		tracker.on("mqtt:u/" + who + "/resource/set", handle_resources_set.bind(this));
	}
}

function viewResource(data) {
	const resourcePermission = this._permissions?.resources;
	if(resourcePermission === 0) return;
	var resourceList = this._resourcesList;
	var resourceId = data.id;
	var resource = resourceList[resourceId];
	if(!resource) return;
	this.extend({
		resourceDetail: resource
	});
	this._viewingResource = resourceId;
	this.dispatch("detail");
	this.api.manage.resources.saveViewed(this._who, resourceId);
	this.emit("usermetrics:trigger:track", "view managed user's resource", {
		resource: resourceId
	});
}

function closeResource() {
	this.extend({
		resourceDetail: null
	});
	this._viewingResource = null;
}

function reset() {
	this._rawList = [];
	this._viewingResource = null;
	this.push({
		resources: [],
		resourceDetail: null
	});
}

function handle_resource_added(data){
	var resource = data.resource;
	var list = this._rawList;
	var newList = list.concat(resource);

	this._rawList = newList;
	this.recalculate();
}

function handle_resource_removed(data){
	var resource = data.resource;
	var list = this._rawList;
	var newList = list.filter(function(res){
		return res !== resource;
	});

	this._rawList = newList;
	this.recalculate();
}

function startEditResources(){
	if(!this._who) return;
	this.dispatch("editing");
	this.emit("usermetrics:trigger:track", "begin editing managed user's resources", {
		who: this._who
	});
}

function finishEditResources(data){
	var who = this._who;
	var group = this._group;
	if(!who) return;
	var resources = Object.keys(data).filter(function(key){
		return data[key];
	});
	this.api.manage.resources.set(who, resources, group)
		.then(function(){
			this.dispatch("finished");
		}.bind(this));
	this.emit("usermetrics:trigger:track", "edit managed user's resources", {
		who: who,
		resources: resources
	});
}

function cancelEditResources(){
	if(!this._who) return;
	this.dispatch("open");
	this.emit("usermetrics:trigger:track", "cancel editing managed user's resources", {
		who: this._who
	});
}

function handle_resources_set(data){
	var newList = data.resources;
	this._rawList = newList;
	this.recalculate();
}

function handlePermissionUpdate(data){
	this._permissions = data;
}